// extracted by mini-css-extract-plugin
module.exports = {"container":"ZoidDatasetPlugin_container__21ZrR","divWidthHeightOverrideParent":"ZoidDatasetPlugin_divWidthHeightOverrideParent__xpVO7"};